var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.233 69.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,25.149A7.663,7.663,0,0,1,25.149,17.5H43.738V7.654a3.28,3.28,0,0,0-3.28-3.28H29.44a8.739,8.739,0,0,0-15.141,0H3.28A3.28,3.28,0,0,0,0,7.654V53.579a3.28,3.28,0,0,0,3.28,3.28H17.5ZM21.869,5.467a3.28,3.28,0,1,1-3.28,3.28A3.28,3.28,0,0,1,21.869,5.467Zm25.149,33.9H61.233V66.7a3.28,3.28,0,0,1-3.28,3.28h-32.8a3.28,3.28,0,0,1-3.28-3.28V25.149a3.28,3.28,0,0,1,3.28-3.28H43.738V36.084A3.29,3.29,0,0,0,47.018,39.364Zm14.215-5.2v.828H48.112V21.869h.828a3.28,3.28,0,0,1,2.319.961l9.013,9.013a3.281,3.281,0,0,1,.961,2.32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.2cde0c65.svg";
export { ForwardRef as ReactComponent };